import React from "react";
import ReactDOM from "react-dom";
import "./config";

import App from "./App";
import { AuthContextProvider } from "./context/AuthContext";
import CustomRouter from "./components/CustomRouter/CustomRouter";

import "react-datepicker/dist/react-datepicker.css";

import "@shltelemedicine/shl-ui-lib/dist/css/main.css";
import "./index.css";
import "./styles/tree.css";
import { AppContextProvider } from "./context/AppContext";
import { browserHistory } from "./utils/routes.util";

ReactDOM.render(
  <React.StrictMode>
    <CustomRouter history={browserHistory}>
      <AuthContextProvider>
        <AppContextProvider>
          <App />
        </AppContextProvider>
      </AuthContextProvider>
    </CustomRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
